import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import labtestService from "../../../Services/labtestservices";


const LabTestServices = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [labTests, setLabTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLabTests = async () => {
      try {
        setLoading(true);
        const response = await labtestService.fetchAll();
        setLabTests(response.services || []);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching lab tests.");
      }
    };
    fetchLabTests();
  }, []);

  useEffect(() => {
    const filtered = labTests.filter((test) =>
      test.name.toLowerCase().includes(searchData.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchData, labTests]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData.slice(startIndex, endIndex));
  }, [currentPage, filteredData]);

  return (
    <div className="p-4">
      <h1 className="ml-[3%] text-[24px] text-gray-700 font-[700]">Lab Test Services</h1>
      <h1 className="ml-[3%] text-[9px] bg-[#F07F1B] py-[3px] text-center rounded-full w-24 text-white font-bold">
        {filteredData.length} records found
      </h1>

      <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
        <Link to="addlabtest">
          <button className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white px-8 py-2 rounded-full duration-300">
            + Lab Test
          </button>
        </Link>

        <div className="w-[40%]">
          <input
            type="search"
            placeholder="Search Here..."
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
            className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
          />
          <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
        </div>
      </div>

      <div className="mx-[3%] rounded-lg">
        <table className="w-[100%] rounded-lg overflow-hidden">
          <thead className="bg-gray-700">
            <tr className="text-white capitalize leading-normal text-center text-[12px]">
              <th className="py-4 w-[15%] text-left pl-4">ID</th>
              <th className="py-4 w-[30%] text-left">Lab Test</th>
              <th className="py-4 w-[20%] text-center">Price</th>
              <th className="py-4 w-[20%] text-center">Discount</th>
              <th className="py-4 w-[15%] text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((test) => (
              <tr
                key={test.id}
                className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200"
              >
                <td className="w-[15%] text-left pl-4 font-[800] text-[#F07F1B]">
                  {test.id}
                </td>
                <td className="py-4 w-[30%] text-left font-[600]">{test.name}</td>
                <td className="py-4 w-[20%] text-center">{test.price}</td>
                <td className="py-4 w-[20%] text-center">{test.discount || 0}%</td>
                <td className="w-[15%] text-center">
                  <button
                    className="bg-gray-100 text-black px-4 py-1 rounded-md border-2"
                    onClick={() => navigate(`addlabtest/${test.id}`)}
                  >
                    Update
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default LabTestServices;
